import { boolean, object } from "yup"

export const smsNotificationsSchema = object({
  smsConsent: boolean().required(),
})
